import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type StaticListFilter } from '../types/filters';

export const CONTINGENT_WORKERS_OPTIONS = [
  { value: '', label: 'Excluded', limit: 1 },
  { value: 'true', label: 'Included', limit: 1 },
];

export const contingentWorkersDefinition: FilterDefinition<StaticListFilter> = {
  id: FilterId.CONTINGENT_WORKERS,
  name: 'Contingent Workers',
  selections: [],
  type: FilterType.STATIC_LIST,
  isVisible: true,
};

export const contingentWorkersHandler: FilterHandler<StaticListFilter> = {
  isActive(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: StaticListFilter) {
    return { ...currentFilterState };
  },
};
